import { createAsyncThunk } from '@reduxjs/toolkit';

import { selectBulkTrade } from '@/store/bulkTrade/selectors.ts';
import { bulkTradeSlice } from '@/store/bulkTrade/slice.ts';
import { subscribeBulkTradeToEsp } from '@/store/bulkTrade/thunks/subscribeBulkTradeToEsp.ts';
import type { AppState } from '@/store/store.ts';

export const changeBulkTradeCurrencyPair = createAsyncThunk(
  'bulkTrade/changeCurrencyPair',
  async (payload: { tabId: string; bulkTradeId: string; currencyPair: string }, thunkAPI) => {
    const { tabId, bulkTradeId, currencyPair } = payload;

    const state = thunkAPI.getState() as AppState;
    const bulkTrade = selectBulkTrade(state, tabId);

    // is the same currency pair, do nothing
    if (bulkTrade?.currencyPair === currencyPair) {
      return;
    }

    thunkAPI.dispatch(bulkTradeSlice.actions.currencyPairChanged({ bulkTradeId, tabId, currencyPair }));

    thunkAPI.dispatch(subscribeBulkTradeToEsp({ tabId }));
  },
);
